import { render } from "./ShareCard.vue?vue&type=template&id=576098dd&scoped=true"
import script from "./ShareCard.vue?vue&type=script&lang=js"
export * from "./ShareCard.vue?vue&type=script&lang=js"

import "./ShareCard.vue?vue&type=style&index=0&id=576098dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576098dd"]])

export default __exports__